import React from 'react'
import { Link } from 'react-router'
import styles from './_friendsHeader.css'
import PageHeader from 'components/util/PageHeader'
import { FormattedMessage } from 'react-intl'

export default function FriendsHeader () {
  // Applying a CSS modules class with the react-router activeClassName prop is not working.
  // Manually adding the styles with the activeStyle prop.
  const ACTIVE = {
    boxShadow: 'inset 0 3px 0 0px #2F98D9',
    background: '#FFFFFF',
    color: '#444444',
  }
  return (
    <div>
      <PageHeader>
        <h1>
          <FormattedMessage id='friends.mainheader' defaultMessage='My Friends' />
        </h1>
      </PageHeader>
      <div className={styles.tabsContainer}>
        <Link
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/people/friends'>
          <FormattedMessage id='friends.tab.myfriends' defaultMessage='My Friends' />
        </Link>

        <Link
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/people/friends/find'>
          <FormattedMessage id='friends.tab.findfriends' defaultMessage='Find Friends' />
        </Link>

        <Link
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/people/friends/invite'>
          <FormattedMessage id='friends.tab.invitefriends' defaultMessage='Invite Friends' />
        </Link>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/friends/FriendsHeader.jsx